// N.B: When changing this list, make sure to update BASE_COLOUR_COUNT if needed

const themeColours = [
  // BASE COLOURS
  "#38DDFF", // theme secondary (cyan)
  "#6A10FF", // theme primary (violet)
  "#EB22EF", // theme tertiary (magenta)

  "#00C48C", // emerald / green
  "#2FA8FF", // sky blue
  "#1F3C88", // deep blue
  "#FF8A2A", // orange
  "#FFB000", // amber
  "#FF4F5E", // coral red
  "#9B5DE5", // soft purple (non-clashing accent)

  // LIGHT COLOURS
  "#6FE8FF", // cyan-light
  "#9A63FF", // violet-light
  "#F059F3", // magenta-light

  "#5FE3B9", // green-light
  "#74C8FF", // sky-light
  "#4F6DB8", // deep-blue-light
  "#FFB36B", // orange-light
  "#FFD166", // amber-light
  "#FF8A93", // coral-light
  "#C6A3FF", // purple-light

  // DARK COLOURS
  "#00B4D8", // cyan-dark
  "#4B00CC", // violet-dark
  "#C915C9", // magenta-dark

  "#009B6F", // green-dark
  "#1F7BD6", // sky-dark
  "#162C66", // deep-blue-dark
  "#CC6415", // orange-dark
  "#CC8A00", // amber-dark
  "#C9353F", // coral-dark
  "#6F2DBD", // purple-dark
];

export default themeColours;
